<p *ngIf="_report">
  <a href="{{embed}}"  target="_blank">{{_report.displayName}}</a>
</p>


